"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APPLY_RECORD_PROTECTION_REQUEST_EXAMPLE = exports.removeRecordProtectionRequestSchema = exports.releaseRecordProtectionRequestSchema = exports.applyRecordProtectionRequestSchema = void 0;
const zod_1 = require("zod");
exports.applyRecordProtectionRequestSchema = zod_1.z.object({
    protectedEntityType: zod_1.z.string().min(1),
    protectedEntityId: zod_1.z.string().uuid(),
    protectionCategory: zod_1.z.enum(['LEGAL', 'PRIVACY', 'INVESTIGATION', 'FREEZE', 'RETENTION']),
    protectionTypeId: zod_1.z.string().uuid(),
    appliedBy: zod_1.z.string().uuid(),
    searchRestricted: zod_1.z.boolean().optional(),
    printRestricted: zod_1.z.boolean().optional(),
    exportRestricted: zod_1.z.boolean().optional(),
    apiRestricted: zod_1.z.boolean().optional(),
    mergeRestricted: zod_1.z.boolean().optional(),
    deleteRestricted: zod_1.z.boolean().optional(),
    archiveRestricted: zod_1.z.boolean().optional(),
    editRestricted: zod_1.z.boolean().optional(),
    visibilityLevel: zod_1.z.enum(['NORMAL', 'RESTRICTED', 'HIDDEN']).optional(),
    durationType: zod_1.z.enum(['TEMPORARY', 'PERMANENT', 'RETENTION_PERIOD']),
    expiresAt: zod_1.z.coerce.date().optional(),
    reasonCode: zod_1.z.string().optional(),
    reasonDescription: zod_1.z.string().optional(),
});
exports.releaseRecordProtectionRequestSchema = zod_1.z.object({
    protectionId: zod_1.z.string().uuid(),
    releasedBy: zod_1.z.string().uuid(),
    reasonCode: zod_1.z.string().optional(),
});
exports.removeRecordProtectionRequestSchema = zod_1.z.object({
    protectionId: zod_1.z.string().uuid(),
    removedBy: zod_1.z.string().uuid(),
    reasonCode: zod_1.z.string().optional(),
});
exports.APPLY_RECORD_PROTECTION_REQUEST_EXAMPLE = {
    protectedEntityType: 'Patient',
    protectedEntityId: '22222222-2222-2222-2222-222222222222',
    protectionCategory: 'LEGAL',
    protectionTypeId: '66666666-6666-6666-6666-666666666666',
    appliedBy: '99999999-9999-9999-9999-999999999999',
    mergeRestricted: true,
    deleteRestricted: true,
    durationType: 'PERMANENT',
    reasonCode: 'MLC',
};
//# sourceMappingURL=protection.request.js.map